import React from 'react';
import { motion } from 'framer-motion';
import './About.css';

function About() {
    const bio = "I'm a software engineer and digital artist. " +
    "I have a B.A. Computer Science with a minor in digital art + design. " +
    "I'm currently based in the New York City metropolitan area. " +
    "In my free time, I like to read, write, and hang out with my cat.";
    return (
        <motion.div
            initial={{x: "50%"}}
            animate={{x: 0}}
            exit={{x: window.innerWidth}}
            transition={{type: "spring", bounce: 0.3, duration: 0.2}}
        >
            <h2>About</h2>
            <div className="aboutBlock">
                <h3 className="bio">Hi, I'm Charlotte!</h3>
                <p className="bio">
                    {bio}
                </p>
            </div>
        </motion.div>
    );
}

export default About;